import { render, staticRenderFns } from "./AddFilter.vue?vue&type=template&id=274dc90a"
import script from "./AddFilter.vue?vue&type=script&lang=js"
export * from "./AddFilter.vue?vue&type=script&lang=js"
import style0 from "./AddFilter.vue?vue&type=style&index=0&id=274dc90a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports